import styled from '@emotion/styled'
import {
  border, color, layout, space, typography, variant,
} from 'styled-system'

const Text = styled.div`
  ${border}
  ${color}
  ${layout}
  ${space}
  ${typography}
  ${variant({
    variants: {
      ellipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '1.3',
      },
      twoLineEllipsis: {
        display: '-webkit-box',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        MozBoxOrient: 'vertical',
        lineHeight: '1.3',
      },
    },
  })}
`

Text.defaultProps = {
  color: 'bodyFontColor',
}

export default Text
